import React, {h, Component} from 'preact';
import {PropTypes} from 'preact-compat';

import ExitIntent from './ExitIntent';
import './exit-intent-modal.scss';
import AwardsSVG from './AwardsSVG';

export default class ExitIntentModal extends Component {
    static get propTypes() {
        return {
            isBuyer: PropTypes.boolean,
            currentStep: PropTypes.string,
            savings: PropTypes.string,
            stateFullName: PropTypes.string
        };
    }

    state = {
        showExitPopup: false
    };
    removeExitIntent;
    modalRef;

    componentDidMount() {
        if (document.cookie.indexOf('exit_popup_seen=true') < 0) {
            this.removeExitIntent = ExitIntent({
                threshold: 30,
                eventThrottle: 100,
                onExitIntent: () => {
                    this.setState({showExitPopup: true});
                    let expiryDate = new Date(Date.now() + 1000 * 60 * 60 * 24);
                    document.cookie = `exit_popup_seen=true; expires=${expiryDate}`;
                    setTimeout(() => {
                        $(this.modalRef)
                            .modal()
                            .on('hide.bs.modal', this.handleModalClose);
                    }, 300);
                    trackEvent(
                        'Flow',
                        this.props.isBuyer ? 'BuyRequest' : 'SellRequest',
                        this.props.isBuyer ? 'buyExitIntentRequestPopupViewed' : 'sellExitIntentRequestPopupViewed',
                        {
                            step: this.props.currentStep
                        }
                    )
                        .withOptimizely()
                        .withGA();
                }
            });
        }
    }

    componentWillUnmount() {
        this.removeExitIntent && this.removeExitIntent();
    }

    handleModalClose = () => {
        trackEvent(
            'Flow',
            this.props.isBuyer ? 'BuyRequest' : 'SellRequest',
            this.props.isBuyer ? 'buyExitIntentRequestPopupClicked' : 'sellExitIntentRequestPopupClicked',
            {
                step: this.props.currentStep
            }
        )
            .withOptimizely()
            .withGA();
        this.setState({showExitPopup: false});
    };

    render() {
        if (!this.state.showExitPopup) {
            return null;
        }

        return (
            <div
                ref={ref => (this.modalRef = ref)}
                className="modal nu-modal fade in exit-intent-popup"
                role="dialog"
                style="display: none;">
                <div className="nu-modal-content">
                    <div className="modal-dialog">
                        <div className="modal-content side-by-side">
                            <div className={`modal-image${this.props.isBuyer ? ' buy' : ''} text-center`}></div>
                            {this.props.isBuyer ? (
                                <div className="modal-body">
                                    <h4 className="body-header">
                                        Don’t miss out on
                                        <br />
                                        this exclusive offer
                                    </h4>
                                    <p>
                                        Get a <span className="highlight">$150 Amazon Gift Card</span>
                                        <br />
                                        when you buy with an UpNest network agent*.
                                    </p>
                                    <p>Finish signing up to see thousands of dollars in commission refunds!</p>
                                    <div
                                        onClick={() => $(this.modalRef).modal('hide')}
                                        className="btn btn-default cta-button">
                                        Continue
                                    </div>
                                    <AwardsSVG />
                                    <p className="disclaimer">*Offer is paid out after closing. </p>
                                </div>
                            ) : (
                                <div className="modal-body">
                                    <h4 className="body-header">
                                        Don’t miss out
                                        <br />
                                        on the savings!
                                    </h4>

                                    {this.props.savings && [
                                        <p>
                                            Home sellers in{' '}
                                            <span className="highlight">{this.props.stateFullName}</span> are saving
                                            <br />
                                            an average of <span className="highlight">{this.props.savings}</span> on
                                            real estate agent
                                            <br />
                                            fees using UpNest.
                                        </p>,
                                        <p>
                                            Finish signing up to see thousands of dollars
                                            <br />
                                            in commission discounts!
                                        </p>
                                    ]}
                                    {!this.props.savings && (
                                        <p>
                                            Home sellers are saving <span className="highlight">over $4k</span> in real
                                            estate agent fees using UpNest.
                                        </p>
                                    )}
                                    <div onClick={() => $(this.modalRef).modal('hide')} className="btn btn-default cta-button">
                                        Continue
                                    </div>
                                    <AwardsSVG />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
